import React from 'react';
import { HandHistoryProvider } from 'contexts/HandHistoryContext';
import { useHandHistory } from 'hooks/useHandHistory';

import { HandHistoryTrigger } from 'components/HandHistory';
import { handHistoryScenarios } from 'components/HandHistory/__fixtures__/handHistory.fixtures';
import { withPreviewPlayerCount } from 'components/HandHistory/__fixtures__/previewPlayerCount';
import styles from 'components/HandHistory/HandHistory.module.scss';
import { HandHistoryDemoControls } from 'components/HandHistory/HandHistoryDemoControls';
import {
  HandHistoryDemoProvider,
  useDemoPlayerCount
} from 'components/HandHistory/HandHistoryDemoProvider';
import { HandHistoryDemoTable } from 'components/HandHistory/HandHistoryDemoTable';
import { getPotTotal } from 'components/HandHistory/handSummary';
import { HandHistoryPlaygroundPanel } from 'components/HandHistory/HandHistoryProposals';

const PreviewTable = () => {
  const { data, selectedIndex, demoGameMode, demoVariant } = useHandHistory();
  const { demoPlayerCount } = useDemoPlayerCount();
  // Keep the table visible while demonstrating the locked history panel.
  const mode = demoVariant === 'texas' ? demoGameMode : 'cash';
  const hand =
    data.completedHands[selectedIndex] ??
    withPreviewPlayerCount(
      handHistoryScenarios[mode][demoVariant].completedHands[0],
      demoPlayerCount
    );

  return (
    <div className={styles.previewTable}>
      <HandHistoryDemoTable
        key={`${hand.handId}-${hand.tableSnapshot.seats.length}`}
        snapshot={hand.tableSnapshot}
        gameType={hand.gameType}
        gameVariant={hand.gameVariant}
        bettingStructure={hand.bettingStructure}
        metadata={hand.metadata}
        potTotal={getPotTotal(hand)}
        potGroups={hand.potGroups}
      />
    </div>
  );
};

const HandHistoryPreview = () => (
  <HandHistoryProvider source='demo' defaultOpen>
    <HandHistoryDemoProvider>
      <main className={styles.previewPage}>
        <PreviewTable />
        <HandHistoryDemoControls />
        <HandHistoryTrigger />
        <HandHistoryPlaygroundPanel />
      </main>
    </HandHistoryDemoProvider>
  </HandHistoryProvider>
);

export default HandHistoryPreview;
